import { keepPreviousData } from '@tanstack/react-query';
import { TableState } from '@optimus-web/core';
import {
    PortfolioEnterpriseGroupFilters,
    PortfolioEnterpriseGroupResult,
    useRepositoryQuery,
} from '@mews-commander/data-access';

export const usePropertiesGroupsData = (
    tableState?: TableState<PortfolioEnterpriseGroupResult, PortfolioEnterpriseGroupFilters>
) => {
    const state = tableState ?? {
        pagination: { pageSize: 0, pageIndex: 0 },
    };
    return useRepositoryQuery('portfolioEnterpriseGroups', 'getAll', state, {
        placeholderData: keepPreviousData,
    });
};
